import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import useUIEditor from 'assets/hooks/uiEditor/UIEditor';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { UICommand } from 'assets/utils/dom/Commands';

export default function ContractRefundPaymentEmailTemplateTags() {
  const { lang } = getLocales();
  const uiEditor = useUIEditor();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-plus" />}
      buttonBody={lang.addPlaceholder}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      tabIndex={null}
      htmlElementProps={{
        title: lang.addEmailTemplatePlaceholder,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={[
            { id: '{{IEmailTemplate_SenderName}}', title: lang.senderName },
            { id: '{{IPayee_Name}}', title: lang.payeeName },
            { id: '{{IPayee_Address}}', title: lang.payeeAddress },
            { id: '{{IPayee_Email}}', title: lang.payeeEmail },
            { id: '{{IPayee_PhoneNumber}}', title: lang.payeePhoneNumber },
            { id: '{{ContractRefundPayment_ReferenceNumber}}', title: lang.referenceNumber },
            { id: '{{ContractRefundPayment_PaymentMethodCode}}', title: lang.paymentMethod },
            { id: '{{ContractRefundPayment_AmountPaid}}', title: lang.paidAmount },
            { id: '{{ContractRefundPayment_GstHstAmountPaid}}', title: lang.gstHstPaid },
            { id: '{{ContractRefundPayment_ProvincialSalesTaxAmountPaid}}', title: lang.pstPaid },
            { id: '{{ContractRefundPayment_TotalPaidAmt}}', title: lang.total },
            { id: '{{ContractRefundPayment_Currency}}', title: lang.currency },
            { id: '{{ContractRefundPayment_Status}}', title: lang.status },
            { id: '{{ContractRefundPayment_ChequeNumber}}', title: lang.chequeNumber },
            { id: '{{ContractRefundPayment_TransactionNumber}}', title: lang.paymentTransactionNumber },
            { id: '{{ContractRefundPayment_PaymentDateUtc}}', title: lang.paymentDate },
            { id: '{{ContractRefundPayment_TransactionDateUtc}}', title: lang.transactionDate },
            { id: '{{ContractRefundPayment_NumberOfItems}}', title: lang.numberOfItems },
            { id: '{{ContractRefundPaymentDetail_AmountPaid}}', title: lang.paidAmount },
            { id: '{{ContractRefundPaymentDetail_PaymentDate}}', title: lang.paymentDate },
            { id: '{{ContractRefundPaymentDetail_RefundJobIds}}', title: lang.refundJobIds },
            { id: '{{ContractRefundPaymentDetail_AppNumbers}}', title: lang.appNumbers },
            { id: '{{ContractRefund_JobId}}', title: `${lang.contractRefund} ${lang.jobNumber}` },
            { id: '{{ContractRefund_NewAppNumber}}', title: lang.newAppNumber },
            { id: '{{ContractRefund_StatusCode}}', title: lang.status },
            { id: '{{Contract_AppNumber}}', title: `${lang.contract} ${lang.appNumber}` },
            { id: '{{Dealer_Name}}', title: lang.dealerName },
            { id: '{{LedgerAccount_LedgerAccountName}}', title: lang.ledgerAccountName },
          ]}
          render={({ data }) => (
            <Button
              key={data.id}
              class={ThemeButtonMenuItem}
              render={data.title}
              onClick={(data) => uiEditor.applyUiCommand(UICommand.insertHTML, data)}
              data={data.id}
            />
          )}
        />
      }
    />
  );
}
